import { PluginKey } from '@tiptap/pm/state';
import { Node_Type } from 'ricos-types';

export const collapsibleModals = {
  settings: `${Node_Type.COLLAPSIBLE_LIST}.settings`,
};

export const collapsibleStateManagerPlugin = new PluginKey('collapsibleStateManager');
